<div class="centerInGrid">
<app-button
        label="Set" 
        [severity]="'warning'"
        [outlined]="false" 
        (onClickEvent)="onClick()">
    </app-button>
</div>
